(function () {
  if (window.torvaHomepageTrackingReady) {
    return;
  }

  window.torvaHomepageTrackingReady = true;
  var homepage = document.querySelector('.home-water');

  if (homepage) {
    homepage.dataset.homepageTrackingReady = 'true';
  }

  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest('.home-water a[data-homepage-area]');

      if (!link) {
        return;
      }

      link.closest('.home-water').dataset.homepageLastAction = link.dataset.homepageAction;

      var eventParameters = {
        homepage_area: link.dataset.homepageArea,
        homepage_action: link.dataset.homepageAction,
        link_url: link.href,
        send_to: 'G-3MFV62R9VK',
        transport_type: 'beacon',
      };

      if (typeof window.gtag === 'function') {
        window.gtag('event', 'torva_homepage_click', eventParameters);
        return;
      }

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'torva_homepage_click',
        homepage_area: eventParameters.homepage_area,
        homepage_action: eventParameters.homepage_action,
        link_url: eventParameters.link_url,
      });
    },
    true
  );
})();
